import React from "react";
import { motion } from "framer-motion";
import azimuthiaImg from "../assets/azimuthia.png"; 
import copcupImg from "../assets/copcup.png";
import eagleCarsImg from "../assets/eagle-cars.png";
import carpoolingImg from "../assets/gotown.png";
import jobSeekerImg from "../assets/job-seeker.png";
import roamifyImg from "../assets/roamify.png";
import zestiLiveImg from "../assets/zesti.png";
import footballClubImg from "../assets/scout-hub.png";
import goShopImg from "../assets/go-shop.png";
import fitnessAppImg from "../assets/fitness.png";

const Portfolio = () => {
  // Projects updated with your specific PDF names and relevant placeholder images
  const projects = [
    {
      title: "CopCup",
      pdf: "/pdfs/CopCup Portfolio.pdf",
      img: copcupImg,
    },
    {
      title: "Eagle Cars",
      pdf: "/pdfs/Eagle Cars Portfolio.pdf",
      img: eagleCarsImg,
    },
    {
      title: "Carpooling App",
      pdf: "/pdfs/Carpooling Portfolio.pdf",
      img: carpoolingImg,
    },
    {
      title: "Job Seeker App",
      pdf: "/pdfs/Job Seeker App Portfolio.pdf",
      img: jobSeekerImg,  
    },

    {
      title: "Fitness App",
      pdf: "/pdfs/Fitness App Portfolio.pdf",
      img: fitnessAppImg,
    },
    {
      title: "Azimuthia",
      pdf: "/pdfs/Azimuthia.pdf",
      img: azimuthiaImg,
    },

    {
      title: "Football Club App",
      pdf: "/pdfs/Football Club App Portfolio.pdf",
      img: footballClubImg,
    },
    {
      title: "Go Shop App",
      pdf: "/pdfs/Go Shop App Portfolio.pdf",
      img: goShopImg,
    },

    {
      title: "Roamify",
      pdf: "/pdfs/Portfolio Roamify.pdf",
      img: roamifyImg,
    },
    {
      title: "Zesti Live",
      pdf: "/pdfs/Zesti Live Portfolio.pdf",
      img: zestiLiveImg,
    },
  ];

  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { delay: i * 0.1, type: "spring", stiffness: 120 }, // Slightly faster staggered delay
    }),
  };

  return (
    <section id="portfolio" className="min-h-screen bg-gray-100 px-6 py-20">
      <div className="text-center mb-16">
        <h2 className="text-4xl md:text-5xl font-bold text-blue-600 mb-4">
          Portfolio
        </h2>
        <p className="text-gray-700 max-w-2xl mx-auto text-lg md:text-xl">
          A showcase of some of our best projects combining design and
          technology.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
        {projects.map((project, index) => (
          <motion.a
            href={project.pdf}
            target="_blank"
            rel="noopener noreferrer"
            key={index}
            custom={index}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={cardVariants}
            className="bg-white rounded-xl shadow-md hover:shadow-xl transition-all transform hover:-translate-y-2 p-4 flex flex-col items-center text-center group cursor-pointer decoration-transparent"
          >
            {/* Project Image */}
            <div className="relative w-full h-40 mb-4 overflow-hidden rounded-lg">
              <img
                src={project.img}
                alt={project.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              {/* Overlay Icon/Text to indicate it's a viewable document */}
              <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-all duration-300 flex items-center justify-center">
                <span className="text-white opacity-0 group-hover:opacity-100 font-medium px-4 py-2 border-2 border-white rounded-lg backdrop-blur-sm transition-opacity duration-300">
                  View PDF
                </span>
              </div>
            </div>

            {/* Project Title */}
            <p className="font-semibold text-gray-700 text-lg group-hover:text-blue-600 transition-colors">
              {project.title}
            </p>
          </motion.a>
        ))}
      </div>
    </section>
  );
};

export default Portfolio;
